/**
 * @generated SignedSource<<4db6765d071b00ba185e73112a5a5b0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithQuote_shoppingWith$data = {
  readonly quote: {
    readonly authorName: string | null;
    readonly image: string | null;
    readonly quoteBody: string | null;
  } | null;
  readonly " $fragmentType": "ShoppingWithQuote_shoppingWith";
};
export type ShoppingWithQuote_shoppingWith$key = {
  readonly " $data"?: ShoppingWithQuote_shoppingWith$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithQuote_shoppingWith">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShoppingWithQuote_shoppingWith",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ShoppingWithQuote",
      "kind": "LinkedField",
      "name": "quote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "authorName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quoteBody",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ShoppingWith",
  "abstractKey": null
};

(node as any).hash = "0d85da2f98373cb8f13015826d36dc91";

export default node;
